import React from 'react'
import { Typography } from 'antd'
import { Organisation } from '../../services/ApiContext'

const { Text } = Typography

interface Props {
  organisation: Organisation
}

export const PrintHeader: React.FC<Props> = ({ organisation }) => {
  return (
    <div className="mb-8">
      <div
        className="h-2 mb-6"
        style={{
          background: `${organisation.primaryColor}`
        }}
      />

      <div className="flex justify-between items-start gap-8">
        {organisation.logo && (
          <img
            src={organisation.logo}
            alt={organisation.name}
            className="w-[150px] object-contain"
          />
        )}

        <div className="text-right">
          <Text strong className="block text-xl">
            {organisation.name}
          </Text>
          <Text className="block whitespace-pre-line">
            {organisation.address}
          </Text>
          {organisation.phone && (
            <Text className="block">{organisation.phone}</Text>
          )}
          {organisation.email && (
            <Text className="block">{organisation.email}</Text>
          )}
        </div>
      </div>
    </div>
  )
}
